
import React from 'react';
import { Button } from '@/components/ui/button';
import { Loader2 } from 'lucide-react';

interface FormActionsProps {
  isSubmitting: boolean;
  onCancel?: () => void;
}

export default function FormActions({ isSubmitting, onCancel }: FormActionsProps) {
  return (
    <div className="flex gap-3 pt-4 border-t border-border">
      {onCancel && (
        <Button 
          type="button" 
          variant="outline" 
          onClick={onCancel} 
          className="flex-1 border-border hover:bg-accent text-foreground text-sm"
          disabled={isSubmitting}
        >
          Cancel
        </Button>
      )}
      <Button 
        type="submit" 
        className="flex-1 app-button-cta font-medium text-sm"
        disabled={isSubmitting}
      >
        {isSubmitting ? (
          <>
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            Sharing Prayer...
          </>
        ) : (
          'Share Prayer'
        )}
      </Button>
    </div>
  );
}
